<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0px; padding-top: 10px">
      <v-row class="sm-mt-5  flex-wrap">
        <v-col cols="12" md="6" class="d-flex flex-wrap course-filter justify-start">
          <v-btn color="secondary" outlined class="mr-2" @click="goBack">
            <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to {{ prevPageName }} List
          </v-btn>

          <v-text-field class="search-box mr-2" placeholder="Search Courses" prepend-icon="fa-search" v-model="search"
            type="text" clearable clear-icon="fa-times" @click:clear="resetSearch"
            @change="applyCourseSearch"></v-text-field>
          <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
            placeholder="Filter course categories" multiple small-chips class="categories search-box"
            v-model="selectedCategory" v-on:change="filterCoursesByCategories($event)"
            menu-props="content-class: dropdown-below" @click:clear="handleClear" prepend-inner-icon="fa-list">
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleSelectAll">
                <v-list-item-action>
                  <v-checkbox :input-value="selectAll" />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
            <template v-slot:selection="{ item, index }">
              <template v-if="index < 2">
                <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
              </template>
              <template v-if="index === 2">
                <v-chip>...</v-chip>
              </template>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-start justify-md-end flex-wrap mt-2 mt-md-0 btn-wrapper">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" class="add-course-button" dark outlined v-bind="attrs" v-on="on">
                More
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item key="archiveData" @click.prevent="showCompletedCoursePanel()">
                <v-list-item-title>Archive Course(s) Data</v-list-item-title>
              </v-list-item>
              <v-list-item key="email" @click.prevent="exportCsv('excel')">
                <v-list-item-title>Email Excel Report</v-list-item-title>
              </v-list-item>
              <v-list-item key="notcompleted" @click.prevent="showNotCompletedCoursePanel()">
                <v-list-item-title>Mark Course(s) Completed</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table"
              :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table"
              :types="{ 'table-heading': '', 'table-thead': 'heading@1', 'table-row': 'text@1' }"
              class="slider-table"></v-skeleton-loader>
            <v-data-table :headers="headers" :options.sync="options" :server-items-length="serverItemsLength"
              v-show="!loading" :items="courses" :footer-props="{
                'items-per-page-options': [5, 10, 15, -1],
              }">
              <template v-slot:item.test_score="{ item }">
                <span v-if="!item.has_test">N/A</span>
                <span v-else>
                  <span v-if="item.test_complete">
                    {{ item.test_score }}%
                  </span>
                  <span v-else>T.B.C</span>
                </span>
              </template>
              <template v-slot:item.progress="{ item }">
                {{ item.progress }}%
              </template>
              <template v-slot:item.has_test="{ item }">
                <span v-if="!item.has_test">N/A</span>
                <span v-else>
                  <span v-if="item.test_complete">
                    <span v-if="item.test_passed">
                      <v-icon color="green">fa-check</v-icon>
                    </span>
                    <span v-else>
                      <v-icon color="red">fa-times</v-icon>
                    </span>
                  </span>
                  <span v-else> T.B.C </span>
                </span>
              </template>

              <!-- 5: Take Test / View Course -->
              <template v-slot:item.id="{ item }">
                <!-- 1: Take Course -->

                <v-tooltip bottom v-if="item.certificate_url && prevPageName == 'Users'">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small text color="secondary" @click.prevent="archiveUserCourse(item.id)">
                      <v-icon small>fas fa-archive</v-icon>
                    </v-btn>
                  </template>
                  <span>Archive</span>
                </v-tooltip>

                <!-- 3: Download Cert / View Course -->
                <v-tooltip bottom v-if="item.certificate_url">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="secondary" text small @click="generatePDF(item.certificate_url)">
                      <v-icon small>fa-certificate</v-icon>
                    </v-btn>
                  </template>
                  <span>Download Certificate</span>
                </v-tooltip>

                <v-tooltip left v-if="item.history_exists">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small text color="secondary" @click.prevent="
                      showUserCourseHistoryPanel(item.id)
                      ">
                      <v-icon small>fas fa-history</v-icon>
                    </v-btn>
                  </template>
                  <span>View Completed Course History</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.manually_completed_by && prevPageName == 'Users'">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="secondary" text small style="cursor: default;">
                      <img contain
                        :src="$globalConfig.APP_NAME === 'senso' ? '/static/blue-tick.png' : '/static/green-tick.png'" />
                    </v-btn>
                  </template>
                  <span>Course Completed By {{ item.manually_completed_by }}</span>
                </v-tooltip>
                <v-tooltip bottom
                  v-if="item.manually_completed_by === '' && !sameUser && prevPageName == 'Users' && item.state != 3">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="secondary" text small @click="markCourseCompleted(item.id, item.course_id)">
                      <img contain :src="'/static/grey-tick.png'" />
                    </v-btn>
                  </template>
                  <span>Mark Course as Completed</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import userAPI from '@/api/user.js';
import courseAPI from '@/api/course.js';
import { EventBus } from '@/event-bus.js';
import CompletedCourses from '@/components/admin/course/CompletedCourse';
import ShowUserCourseHistory from '@/components/admin/course/ShowUserCourseHistory';
import NotCompletedCourse from '@/components/admin/course/NotCompletedCourses';
export default {
  name: 'ActivityWidget',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'Course Title', value: 'title', sortable: false },
        { text: 'Status', value: 'state_text', sortable: false },
        { text: 'Date Enrolled', value: 'enrolled_date_formatted', sortable: false },
        { text: 'Date Started', value: 'start_date_formatted', sortable: false },
        { text: 'Date Completed', value: 'complete_date_formatted', sortable: false },
        { text: 'Progress %', value: 'progress', sortable: false },
        { text: 'Deadline', value: 'deadline_formatted', sortable: false },
        { text: 'Test Score', value: 'test_score', sortable: false },
        { text: 'Passed Test', value: 'has_test', sortable: false },
        { text: '', value: 'id', sortable: false, align: 'end' },
      ],
      id: this.$route.params.id,
      courses: [],
      loading: false,
      pagination: {},
      options: {},
      search: '',
      searchParams: '',
      successMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
      categories: [],
      selectedCategory: [],
      confirmArchive: 'Are you sure you wish to archive course for this user?',
      successArchiveMessage: 'Course Archived Successfully.',
      confirmCompleteCourse: 'Are you sure you wish to complete course for this user?',
      successCourseCompleteMessage: 'Course Completed Successfully.',
      user_id: this.$store.getters.user.id,
    };
  },
  props: {
    total_courses: {
      type: Number,
      default: 0,
    },
    total_in_progress_courses: {
      type: Number,
      default: 0,
    },
    total_completed_courses: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    notStartedCourses: function () {
      return (
        this.total_courses -
        this.total_in_progress_courses -
        this.total_completed_courses
      );
    },
    notStartedPercentage: function () {
      return this.getWholePercent(this.notStartedCourses, this.total_courses);
    },
    inProgessPercentage: function () {
      return this.getWholePercent(
        this.total_in_progress_courses,
        this.total_courses
      );
    },
    completedPercentage: function () {
      return this.getWholePercent(
        this.total_completed_courses,
        this.total_courses
      );
    },
    total: function () {
      return this.total_courses;
    },
    series: function () {
      return [
        this.notStartedPercentage,
        this.inProgessPercentage,
        this.completedPercentage,
      ];
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
    sameUser() {
      return this.id === this.user_id
    },
    prevPageName() {
      const prev = this.$getPreviousRoute();
      if (prev) {
        localStorage.setItem('prev_page',prev.name)
        return prev.name;
      }
      return localStorage.getItem('prev_page');
    }
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
    this.getAllCourseCategories();
    this.loadSearch();
  },
  methods: {
    getWholePercent(percentFor, percentOf) {
      //let precision = Math.pow(10, 1);
      let num = (percentFor / percentOf) * 100;
      return Math.round(num);
    },
    showTest(id) {
      courseAPI
        .getCourse(id, '?include=enrolled,videos,documents,test')
        .then((response) => {
          this.$store.dispatch('setCoursePlayer', response.data.data);
          this.$showPanel({
            component: Test,
            props: {
              course: response.data.data,
            },
            openOn: 'right',
          });
        });
    },
    setEventBus() {
      EventBus.$on('ANSWERS_SUBMITTED', (payload) => {
        this.getCourses();
      });
    },
    generatePDF(url) {
      if (url != null) {
        window.open(url, '_blank');
      }
    },
    getCourses() {
      this.loading = true;
      userAPI.getArchivedUserCourses(this.id, this.params, this.searchParams).then((resp) => {
        this.courses = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    exportCsv(type) {
      this.loading = true;
      courseAPI
        .exportUserCourseReportCSV(
          this.id,
          '?page=1&orderBy=&sortedBy=asc&limit=' + this.pagination.total,
          '&type=' + type
        )
        .then(() => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },
    resetSearch() {
      this.options.page = 1;
      this.search = '';
      localStorage.removeItem('user-course-report-search');
      this.applyCourseSearch();
    },
    saveSearch() {
      // Save search value to localStorage
      localStorage.setItem('user-course-report-search', this.search);
    },
    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('user-course-report-search');

      if (savedSearch && savedSearch !== 'null') {
        this.search = savedSearch;
      }
    },
    applyCourseSearch() {
      this.options.page = 1;
      this.searchParams = '';
      this.searchParams = this.search && this.search.length > 0
        ? '&course_name=' + this.search : '';

      if (this.selectedCategory.length) {
        this.searchParams += '&categories=' + this.selectedCategory.toString();
      }

      this.getCourses();

      if (this.search && this.search.length > 0) {
        this.saveSearch();
      }

    },
    getAllCourseCategories() {
      courseAPI.getAllCourseCategories().then(response => {
        this.categories = response.data.data;
      });
    },
    filterCoursesByCategories() {
      this.applyCourseSearch();
    },
    handleClear() {
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory = this.categories.map((cat) => cat.id);
      }

      this.applyCourseSearch()
    },
    showCompletedCoursePanel() {
      this.$showPanel({
        component: CompletedCourses,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    archiveUserCourse(id) {
      this.$snotify.confirm(this.confirmArchive, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processArchiveUserCourse(toast, id),
          },
        ],
      });
    },
    processArchiveUserCourse(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      courseAPI.archiveUserCourse(id).then(() => {
        this.getCourses();
        this.$snotify.success(this.successArchiveMessage);
        this.loading = false;
        setTimeout(() => {
          this.$gf.removeBackdrop();
        }, 300);
      });
    },
    showUserCourseHistoryPanel(id) {
      this.$showPanel({
        component: ShowUserCourseHistory,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    markCourseCompleted(id, courseId) {
      this.$snotify.confirm(this.confirmCompleteCourse, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processCourseComplete(toast, id, courseId),
          },
        ],
      });
    },
    processCourseComplete(toast, id, courseId) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      courseAPI.markCourseCompleted(id, courseId).then(() => {
        this.getCourses();
        this.$snotify.success(this.successCourseCompleteMessage);
        this.loading = false;
        setTimeout(() => {
          this.$gf.removeBackdrop();
        }, 300);
      });
    },
    goBack() {
      const prev = this.$getPreviousRoute();
      if (prev) {
        this.$router.push(prev.fullPath);
      } else {
        this.$router.push('/admin/users'); // optional fallback
      }
    },
    showNotCompletedCoursePanel() {
      this.$showPanel({
        component: NotCompletedCourse,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
  },
  beforeDestroy() {
    EventBus.$off('ANSWERS_SUBMITTED');
  },
};
</script>
<style scoped>
.course-filter {
  padding: 12px;
  gap: 25px;
}

.course-filter .search-box {
  border-radius: 25px;
  max-width: 300px !important;
  height: 40px;
  margin-top: 0;
}

.course-search-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
}

.user-archived-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}

.v-btn:not(.v-btn--round).v-size--small {
  min-width: 25px !important;
  padding: 0 4.5px !important;
}

@media (max-width: 960px) {
  .user-archived-button-wrapper {
    justify-content: start;
  }
}
@media (max-width: 768px) {
  .btn-wrapper{
    display: block !important;
  }
}
</style>
